import { Container } from "@mantine/core"
import {
  getCoreRowModel,
  getSortedRowModel,
  SortingState,
  useReactTable,
} from "@tanstack/react-table"
import { Dispatch, SetStateAction, useState } from "react"
import z from "zod"

import { CountryIso3166Schema } from "@tfg/types/schemas/enum"
import { standardEmail } from "@tfg/types/schemas/utils"

import { Table } from "~/components/table/Table.tsx"
import {
  CreateSupplierMappingRequestDto,
  FindSupplierMappingResponseDto,
  UpdateSupplierMappingRequestDto,
} from "~/gen/api/types"
import { useColumns } from "~/pages/Brand/OrganizationSettings/Suppliers/hooks/columns.tsx"
import {
  errorMap,
  StringNoSpecialCharactersSchema,
} from "~/pages/SupplierPortal/TraceabilityRequests/components/ZodCustomErrorMap.tsx"

export type SupplierProps = {
  suppliers: FindSupplierMappingResponseDto[]
  searchSupplier: string
  setInitialValues: Dispatch<
    SetStateAction<
      CreateSupplierMappingRequestDto | UpdateSupplierMappingRequestDto
    >
  >
  setValuesUpdated: Dispatch<SetStateAction<boolean>>
  setFormType: Dispatch<SetStateAction<"create" | "update">>
}

export const formSchema = z.object({
  name: StringNoSpecialCharactersSchema,
  email: standardEmail(),
  company: z.object({
    name: z.string({ errorMap }).min(2).max(100),
    street: z.string({ errorMap }).min(2).nullable(),
    city: z.string({ errorMap }).min(2).nullable(),
    postalCode: z.string({ errorMap }).min(1).nullable(),
    country: CountryIso3166Schema,
  }),
})
export function Suppliers({
  suppliers,
  setValuesUpdated,
  setInitialValues,
  setFormType,
  searchSupplier,
}: SupplierProps) {
  const [sorting, setSorting] = useState<SortingState>([
    { id: "email", desc: false },
  ])
  const columns = useColumns({
    setInitialValues,
    setValuesUpdated,
    setFormType,
    searchSupplier,
  })

  const table = useReactTable({
    data: suppliers,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
  })

  return (
    <Container fluid>
      <Table table={table} pagination={false} />
    </Container>
  )
}
